const STATION_TOKEN_HEADER = 'X-Eldercare-Station-Token'
const STATION_TOKEN_KEY = 'eldercareStationToken'
const STATION_WINDOW_ID_KEY = 'eldercareStationWindowId'
const STATION_SEQUENCE_KEY = 'eldercareStationSequence'
const STATION_TOKEN_HEADER_LOWER = STATION_TOKEN_HEADER.toLowerCase()

function getStorage () {
  if (typeof window === 'undefined' || !window.sessionStorage) return null
  return window.sessionStorage
}

function getStationToken () {
  const storage = getStorage()
  return storage ? storage.getItem(STATION_TOKEN_KEY) : null
}

function getStationWindowId () {
  const storage = getStorage()
  return storage ? storage.getItem(STATION_WINDOW_ID_KEY) : null
}

function saveStationWindowId (windowId) {
  const storage = getStorage()
  if (storage && windowId) storage.setItem(STATION_WINDOW_ID_KEY, String(windowId))
}

function saveStationSession (result, windowId, switchSequence) {
  const storage = getStorage()
  const token = result && typeof result.token === 'string' ? result.token.trim() : ''
  if (!storage || !token || !windowId) throw new Error('站点登录凭证无效')
  storage.setItem(STATION_TOKEN_KEY, token)
  storage.setItem(STATION_WINDOW_ID_KEY, String(windowId))
  if (switchSequence !== undefined && switchSequence !== null) {
    storage.setItem(STATION_SEQUENCE_KEY, String(switchSequence))
  }
}

function markStationSequence (switchSequence) {
  const storage = getStorage()
  if (storage && switchSequence !== undefined && switchSequence !== null) {
    storage.setItem(STATION_SEQUENCE_KEY, String(switchSequence))
  }
}

function isCurrentStationSequence (switchSequence) {
  const storage = getStorage()
  if (!storage) return true
  return storage.getItem(STATION_SEQUENCE_KEY) === String(switchSequence)
}

function clearStationSession () {
  const storage = getStorage()
  if (!storage) return
  storage.removeItem(STATION_TOKEN_KEY)
  storage.removeItem(STATION_WINDOW_ID_KEY)
  storage.removeItem(STATION_SEQUENCE_KEY)
}

function clearStationSessionIfCurrent (requestToken) {
  const token = requestToken === undefined || requestToken === null
    ? ''
    : String(requestToken).trim()
  if (!token || getStationToken() !== token) return false
  clearStationSession()
  return true
}

function addStationToken (config) {
  const token = getStationToken()
  if (!token || !isSameOriginUrl(config && config.url)) return config
  config.headers = config.headers || {}
  config.headers[STATION_TOKEN_HEADER] = token
  config.__eldercareStationToken = token
  return config
}

function isSameOriginUrl (url) {
  if (typeof window === 'undefined' || !url) return true
  try {
    return new URL(String(url), window.location.href).origin === window.location.origin
  } catch (error) {
    return false
  }
}

function isStationTokenHeader (name) {
  return String(name || '').toLowerCase() === STATION_TOKEN_HEADER_LOWER
}

function installJQueryStationInterceptor () {
  if (typeof window === 'undefined') return
  let bundledJquery = null
  try {
    bundledJquery = require('jquery')
  } catch (error) {
    // The static jQuery asset is enough for deployments without the bundle.
  }
  ;[window.jQuery, bundledJquery].filter(Boolean).forEach(jquery => {
    if (jquery.__eldercareStationInterceptorInstalled) return
    jquery.__eldercareStationInterceptorInstalled = true
    jquery.ajaxPrefilter((options, originalOptions, jqXHR) => {
      const token = getStationToken()
      if (token && isSameOriginUrl(options && options.url)) {
        jqXHR.setRequestHeader(STATION_TOKEN_HEADER, token)
        jqXHR.__eldercareStationToken = token
      }
    })
    jquery(window.document).ajaxError((event, jqXHR) => {
      if (jqXHR && jqXHR.status === 401) {
        clearStationSessionIfCurrent(jqXHR.__eldercareStationToken)
      }
    })
  })
}

function installXhrStationInterceptor () {
  if (typeof window === 'undefined' || !window.XMLHttpRequest) return
  const prototype = window.XMLHttpRequest.prototype
  if (prototype.__eldercareStationInterceptorInstalled) return
  prototype.__eldercareStationInterceptorInstalled = true
  const originalOpen = prototype.open
  const originalSetRequestHeader = prototype.setRequestHeader
  const originalSend = prototype.send
  prototype.open = function (method, url) {
    this.__eldercareStationSameOrigin = isSameOriginUrl(url)
    this.__eldercareStationHeaderSet = false
    this.__eldercareStationHeaderToken = null
    this.__eldercareStationToken = null
    return originalOpen.apply(this, arguments)
  }
  prototype.setRequestHeader = function (name, value) {
    if (isStationTokenHeader(name)) {
      this.__eldercareStationHeaderSet = true
      this.__eldercareStationHeaderToken = String(value || '').trim()
    }
    return originalSetRequestHeader.apply(this, arguments)
  }
  prototype.send = function () {
    const token = getStationToken()
    if (token && this.__eldercareStationSameOrigin) {
      if (this.__eldercareStationHeaderSet) {
        this.__eldercareStationToken = this.__eldercareStationHeaderToken || null
      } else {
        this.__eldercareStationToken = token
        try {
          this.setRequestHeader(STATION_TOKEN_HEADER, token)
        } catch (error) {
          // Some browser-managed requests reject custom headers; leave them alone.
        }
      }
    }
    if (!this.__eldercareStationErrorHandlerInstalled && typeof this.addEventListener === 'function') {
      this.__eldercareStationErrorHandlerInstalled = true
      this.addEventListener('readystatechange', () => {
        if (this.readyState === 4 && this.status === 401) {
          clearStationSessionIfCurrent(this.__eldercareStationToken)
        }
      })
    }
    return originalSend.apply(this, arguments)
  }
}

function isLogoutRequest (config) {
  const url = config && config.url ? String(config.url) : ''
  return /(?:^|\/)logout(?:\?|$)/.test(url)
}

function installStationSessionInterceptors (axios) {
  if (!axios || axios.__eldercareStationInterceptorsInstalled) return
  axios.__eldercareStationInterceptorsInstalled = true
  installJQueryStationInterceptor()
  installXhrStationInterceptor()
  axios.interceptors.request.use(addStationToken)
  axios.interceptors.response.use(response => {
    if (isLogoutRequest(response && response.config)) {
      clearStationSessionIfCurrent(response.config.__eldercareStationToken)
    }
    return response
  }, error => {
    if (error && error.response && error.response.status === 401) {
      clearStationSessionIfCurrent(error.config && error.config.__eldercareStationToken)
    }
    return Promise.reject(error)
  })
}

module.exports = {
  STATION_TOKEN_HEADER,
  STATION_TOKEN_KEY,
  STATION_WINDOW_ID_KEY,
  getStationToken,
  getStationWindowId,
  saveStationWindowId,
  saveStationSession,
  markStationSequence,
  isCurrentStationSequence,
  clearStationSession,
  clearStationSessionIfCurrent,
  addStationToken,
  installStationSessionInterceptors,
  installXhrStationInterceptor
}
